import React from 'react';

import ColoringBook from '../coloringBook/ColoringBook';

const GamesColoring = () => {
  return (
    <div>
        <ColoringBook />
    </div>
  )
}

export default GamesColoring;